// BUILD=R23-login-redirect-hardening
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { useDebugMode } from "@/hooks/login/useDebugMode";
import { LoginForm } from "@/components/login";
import DebugSection from "@/components/login/DebugSection";
import { Button } from "@/components/ui/button";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isValidating } = useAuth();
  const isMobile = useIsMobile();
  const {
    showDebugInfo,
    debugOutput,
    toggleDebugMode,
    setShowDebugInfo,
    checkEmployees,
    isLoading
  } = useDebugMode();

  useEffect(() => {
    console.log("[login-flow] Login.tsx effect:", {
      isAuthenticated,
      isValidating,
      path: location.pathname,
    });
    // Wacht tot de eerste sessie-validatie klaar is om te voorkomen dat we
    // op een tussenstaat redirecten. Zodra isAuthenticated true is, route weg.
    if (isAuthenticated && !isValidating) {
      console.log("[login-flow] Login.tsx → navigate('/dashboard')");
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, isValidating, navigate, location.pathname]);

  return (
    <div className={`min-h-screen flex items-center justify-center bg-luijten-gray ${isMobile ? 'p-4' : ''}`}>
      <div className="w-full max-w-md space-y-4">
        <LoginForm onDebugClick={toggleDebugMode} />
        
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-2">
            Nog geen account?
          </p>
          <Button
            variant="outline"
            onClick={() => navigate("/register")}
            className="w-full"
          >
            Registreren
          </Button>
        </div>
        
        {showDebugInfo && (
          <div className="mt-4 bg-white rounded-lg shadow-sm p-4 border rounded-lg">
            <DebugSection 
              showDebugInfo={showDebugInfo}
              setShowDebugInfo={setShowDebugInfo}
              debugOutput={debugOutput}
              checkEmployees={checkEmployees}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
